import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { ROUTES } from "~/utils/routing/routeUtils";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Optional explore destinations after core Property → Building → Unit setup.
 */
const optionalExploreTours = (t: TFunction) => [
  {
    label: t("Tour_Setup_Optional_Organization"),
    path: ROUTES.organization,
  },
  {
    label: t("Tour_Setup_Optional_Amenities"),
    path: ROUTES.amenity,
  },
  {
    label: t("Tour_Setup_Optional_ServiceRequests"),
    path: ROUTES.serviceRequest,
  },
  {
    label: t("Tour_Setup_Optional_Payments"),
    path: ROUTES.payments,
  },
];

/**
 * Setup complete tour on building details (common redirect after add-unit).
 */
export const buildingDetailsSetupCompleteTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Setup_Complete_Title"),
    description: t("Tour_Setup_Complete_Description"),
    target: () => queryTourTarget("building-details-header"),
    placement: "bottom",
    recommendedTours: optionalExploreTours(t),
  },
];

/**
 * Setup complete tour on unit details (when redirect lands on the unit).
 */
export const unitDetailsSetupCompleteTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_Setup_Complete_Title"),
    description: t("Tour_Setup_Complete_Description"),
    target: () => queryTourTarget("unit-details-header"),
    placement: "bottom",
    recommendedTours: optionalExploreTours(t),
  },
];
